export default function normalizeUrl(url: string) {
  if (!url || url.startsWith('/') || url.startsWith('http')) {
    return url;
  }

  return `/${url}`;
}
